<template>
  <b-container fluid :class="`bg-compliance-insights ${zoomGraphValue == 'compliance-insights-card' ? 'radius-5' : ''}`">
    <b-row>
      <b-col xl="3" lg="3" md="3" v-if="zoomGraphValue !== 'compliance-insights-card'">
        <b-row style="margin-top: 32px">
          <img src="@/assets/white-thread.png" height="26" />
        </b-row>
        <b-row style="margin-top: 5px">
          <span
            style="
              font-size: 16px;
              color: white;
              font-family: RobotoMedium;
              font-weight: 500;
            "
            >COMPLIANCE INSIGHTS</span
          >
        </b-row>
        <b-row style="margin-top: 16px" class="parent-overlay">
          <p class="compliance-insight-textarea compliance-text" @scroll="scrollComplianceText">
            The Compliance Dashboard is a compilation of compliance metrics that includes tasks, surveys, ePROs, eDROs, telehealth visits, and learn activities where data is collected within the THREAD Platform. Compliance is defined as completing activities or tasks as indicated by the study milestones. If an activity or task is not completed or completed outside of the scheduled window, it is
            considered to be non-compliant. If your score has improved since last week, it means your performance is increasing. Great job encouraging sites and participants to engage with the study in a timely manner! If your score has decreased since last week, please read below for more insights into how you can improve your score.
            <br /><br />

            There may be many factors impacting compliance such as activity type, geographic region, training, natural disasters and patient population. The Geodemographic Compliance map will indicate where the compliance issues are located, and the Compliance Change Score chart will show trends over time.
            <br /><br />

            These compliance scores can be strongly impacted by individual site compliance scores. Review the "Study Activity Compliance by Day" chart by Sites to see if there is a specific site causing any non-compliance issues. There could also be certain activities that may be more non-compliant than others. The "Top 10 Non-Compliant Activities" chart can highlight any problem activities.
          </p>
          <div class="gradient-overlay" v-if="!isScrolledToBottom"></div>
        </b-row>
      </b-col>
      <b-col xl="3" lg="3" md="3" align-self="center" class="pr-0" v-if="zoomGraphValue !== 'compliance-insights-card'">
        <div class="activity-compliance-score">
          <b-row>
            <span style="margin-top: 12px; margin-left: 12px">
              <span class="activity-compliance-label">Activity Compliance Score </span>
              <i
                class="fa fa-info-circle help-icon"
                v-b-tooltip.hover="{
                  placement: 'rightbottom',
                  title:
                    'This score represents non-compliance within activities that are collected within the THREAD Platform for this study. This score is an aggregation of all of the following activities that are present in your study: clinical data activities, eConsent completion, comprehension quiz completion, eDRO/sensors, participant tasks for telehealth, site team tasks, and agreement documents. Any single item can impact the overall score. The score shown here is based on a scale from 1 to 10 with the higher number being more desirable. The number associated with the up or down arrow represents the change in this score over the past week.'
                }"
              />
            </span>
          </b-row>
          <div class="d-flex justify-center">
            <div style="font-size: 58px; font-weight: bold; color: #ffffff;margin-right: 16px;">
              {{ getComplianceInsightScore }}
            </div>
            <div class="d-flex flex-column justify-center">
              <div :class="newComplianceInsightScore && newComplianceInsightScore.current != undefined ? (newComplianceInsightScore.current.toFixed(1) > newComplianceInsightScore.last.toFixed(1) ? 'chevron-up' : '') : ''"></div>
              <div
                :style="`font-size: 18px; margin-left: ${newComplianceInsightScore.current.toFixed(1) === newComplianceInsightScore.last.toFixed(1) ? '-3px' : '2px'}`"
                v-if="getDiffInsightScore"
                :class="newComplianceInsightScore ? (newComplianceInsightScore.current.toFixed(1) > newComplianceInsightScore.last.toFixed(1) ? 'text-green' : newComplianceInsightScore.current.toFixed(1) === newComplianceInsightScore.last.toFixed(1) ? 'text-grey' : isNaN(newComplianceInsightScore.current) ? 'text-grey' : 'text-red') : ''"
              >
                {{ getDiffInsightScore }}
              </div>
              <div v-else class="align-content" slot="body">
                <div class="card-text-title no-data" v-if="dataLoadedInside.getDiffInsightScore">
                  No Data In
                </div>
              </div>
              <div :class="newComplianceInsightScore && newComplianceInsightScore.current != undefined ? (newComplianceInsightScore.current.toFixed(1) < newComplianceInsightScore.last.toFixed(1) ? 'chevron-down' : '') : ''" />
              <div class="rectangle" style="margin-left: -3px;" v-show="newComplianceInsightScore && typeof newComplianceInsightScore.current !== 'undefined' && typeof newComplianceInsightScore.last !== 'undefined' && newComplianceInsightScore.current.toFixed(1) === newComplianceInsightScore.last.toFixed(1)" />
            </div>
          </div>
        </div>
      </b-col>
      <b-col :xl="zoomGraphValue === 'compliance-insights-card' ? '12' : '6'" :lg="zoomGraphValue === 'compliance-insights-card' ? '12' : '6'" :md="zoomGraphValue === 'compliance-insights-card' ? '12' : '6'" :class="!isShowChart ? 'p-20' : 'px-0'">
        <chart-container
          :titleChart="titleChart"
          @onCSVDownload="downloadCsv(titleChart)"
          @zoomEnabled="zoomGraph(true)"
          @zoomDisabled="zoomGraph(false)"
          :downloadId="downloadId"
          :specificSiteId="specificSiteId"
          :zoomGraphValue="zoomGraphValue"
          :downloadShow="isShowChart"
          class="bg-compliance-insights"
          :class="{ 'no-data-blue': !isShowChart }"
          titleTooltip="This top 10 list represents the top activities that have not been completed or are not completed as required according to the study's milestones. If an activity or task is not completed or completed outside of the scheduled window, it is considered non-compliant."
        >
          <fusioncharts style="width: 100%" :type="type" :width="width" :height="height" :dataFormat="dataFormat" :dataSource="getDataSource" dataEmptyMessage="No Data In" ref="overallChart" v-if="isShowChart" slot="body" />
          <div slot="body" class="text-left min-height-0" v-if="isShowChart">
            <span @click="zoomOutChart()" class="pl-10 pr-5 remove-zoom-icons">
              <img src="/static/img/icon-zoomout.svg" class="download_graph cursor_pointer" aria-haspopup="true" aria-expanded="false" title="Zoom Out" />
            </span>
            <span @click="zoomInChart()" class="remove-zoom-icons">
              <img src="/static/img/icon-zoomin.svg" class="download_graph cursor_pointer" aria-haspopup="true" aria-expanded="false" title="Zoom In" />
            </span>
          </div>
          <div v-else class="align-center p-60" slot="body">
            <div class="card-text-title no-data" v-if="dataLoaded">
              No Data In
            </div>
          </div>
        </chart-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import _cloneDeep from "lodash/cloneDeep";
import _get from "lodash/get";
import _ from "lodash";
import { downloadCSV, getSiteID } from "../../services/visualization/data-management";
import ChartContainer from "./chart-container-dark-blue.vue";
import moment from "moment";
import { ACTIVITIES, COUNTRIES, PARTICIPANTS, SITES } from "@/constants/config";
import { getComplianceInsightNonCompliantActivitiesData, getComplianceScore } from "@/services/visualization/study-compliance";

const dataSources = {
  chart: {
    animation: "1",
    yaxisname: "% Non-Compliance",
    xaxisname: "Activities",
    xAxisNameFontColor: "#fff",
    xAxisNameFont: "RobotoRegular",
    xAxisNameFontSize: "9px",
    labelFontSize: "14px",
    labelFont: "RobotoRegular",
    labelFontColor: "#a3a3a3",
    yAxisNameFontColor: "#fff",
    yAxisNameFont: "RobotoRegular",
    yAxisNameFontSize: "9px",
    yAxisValueFont: "RobotoRegular",
    yAxisValueFontSize: "10px",
    yAxisValueFontColor: "#a3a3a3",
    theme: "fusion",
    baseFontSize: "10",
    tooltipBorderAlpha: "0",
    showToolTipShadow: "0",
    divLineAlpha: "0",
    divLineDashed: "0",
    labelDisplay: "wrap",
    maxLabelHeight: "30",
    useEllipsesWhenOverflow: "1",
    maxColWidth: "42",
    plotHighlightEffect: "fadeout",
    plotSpacePercent: 40,
    reverseLegend: true,
    minimiseWrappingInLegend: true,
    showXAxisLine: false,
    showYAxisLine: false,
    xaxislinethickness: "1",
    yaxislinethickness: "1",
    xAxisLineColor: "#f2f7f9",
    yAxisLineColor: "#f2f7f9",
    palettecolors: "#c3d5ee",
    chartBottomMargin: "0",
    xAxisNamePadding: "5",
    decimals: 3,
    bgColor: "#00000000",
    bgAlpha: "0",
    plotToolText: `<div class="overall-collection-metric-tooltip white"'>
                  <span>$label</span><br/>
                  <span class="data-label-text">$dataValue Non-Compliance</span>
              </div>`,
    numberSuffix: "%",
    maxLabelWidthPercent: 20,
    toolTipBgAlpha: "100",
    toolTipBgColor: "#e2e7ea",
    toolTipColor: "#2d3752",
    tooltipborderradius: "4",
    yAxisMaxValue: 100
  },
  categories: [],
  dataset: []
};
export default {
  components: {
    ChartContainer
  },
  props: {
    customType: { type: String, default: "scrollbar2d" },
    zoomGraphValue: { type: String, default: "" },
    titleChart: { type: String, default: "" },
    subtitleChart: { type: String, default: "" },
    filterTriggered: { type: Boolean, default: false },
    sitesSelected: [Array, String],
    countrySelected: [Array, String],
    collectionMetricsRaw: { default: null },
    participantRaw: { default: null },
    specificSiteId: [Object, Array],
    siteListInParticipants: { type: Array, default: () => [] },
    participantsSelected: { type: Array, default: () => [] },
    listParticipants: [Array, null],
    dataLoaded: { type: Boolean, default: false },
    complianceInsightScoreRaw: { default: null },
    complianceInsightScore: { default: null },
    complianceInsightNonCompliantActivitiesRaw: { default: null },
    complianceInsightNonCompliantActivities: { default: null }
  },
  data() {
    return {
      downloadId: "compliance-insights-card",
      tabList: [ACTIVITIES, COUNTRIES, SITES, PARTICIPANTS],
      xAxisName: ACTIVITIES,
      type: this.customType,
      width: "100%",
      height: "250",
      dataFormat: "json",
      dataSource: dataSources,
      zoomGraphValueChild: "",
      curZoomLevel: 0,
      maxZoomLevel: 3,
      maxColumn: 0,
      todayDate: "",
      tDateShow: true,
      series: {},
      getSiteID,
      dataLoadedInside: {},
      newComplianceInsightScore: null,
      isScrolledToBottom: false
    };
  },

  watch: {
    specificSiteId: function() {
      if (this.specificSiteId.length > 0) {
        this.tabList = [ACTIVITIES];
      }
    },

    filterTriggered: function() {
      if (_.isEmpty(this.participantsSelected)) {
        this.series = {};
        this.newComplianceInsightScore = null;
        return;
      }
      this.series = getComplianceInsightNonCompliantActivitiesData(this.complianceInsightNonCompliantActivitiesRaw, this.countrySelected, this.sitesSelected, this.xAxisName, this.listParticipants);
      this.newComplianceInsightScore = getComplianceScore(this.complianceInsightScoreRaw, this.countrySelected, this.sitesSelected);
    },

    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250";
      }
    },

    series: function(newValue) {
      if (newValue && newValue.categories) {
        const { categories, dataset } = newValue;
        const datasources = _cloneDeep(dataSources);

        dataset[0] = {
          data: dataset[0].data.map(row => {
            if (row.value) {
              return {
                ...row,
                value: Math.round(parseFloat(row.value)),
                valueCSV: parseFloat(row.value)
              };
            }

            return row;
          }),
          plottooltext: this.getPlotToolText("completed")
        };

        if (categories && categories[0].category.length > 0) {
          datasources.categories = [...categories];
          datasources.dataset = dataset;
          this.maxColumn = categories[0].category.length;
        }

        datasources.chart.numvisibleplot = "5";
        datasources.chart.xaxisname = this.xAxisName;
        datasources.chart.maxLabelHeight = "30";

        this.dataSource = datasources;
      } else {
        const datasources = { categories: null };
        this.dataSource = datasources;
      }
    },

    // non compilant activities data
    complianceInsightNonCompliantActivities: function() {
      this.series = getComplianceInsightNonCompliantActivitiesData(this.complianceInsightNonCompliantActivitiesRaw, this.countrySelected, this.sitesSelected);
    },

    complianceInsightScoreRaw: function() {
      this.newComplianceInsightScore = getComplianceScore(this.complianceInsightScoreRaw, this.countrySelected, this.sitesSelected);
      this.dataLoadedInside.newComplianceInsightScore = true;
      this.dataLoadedInside.getDiffInsightScore = true;
    }
  },

  mounted() {
    if (this.series.categories) {
      const datasources = _cloneDeep(dataSources);
      const { categories, dataset } = this.series;
      dataset[0] = {
        data: dataset[0].data.map(row => {
          if (row.value) {
            return {
              ...row,
              value: Math.round(parseFloat(row.value)),
              valueCSV: parseFloat(row.value)
            };
          }

          return row;
        }),
        plottooltext: this.getPlotToolText()
      };

      if (categories && categories[0].category.length > 0) {
        datasources.categories = [...categories];
        datasources.dataset = dataset;
        this.maxColumn = categories[0].category.length;
      }

      datasources.chart.numvisibleplot = 0;
      datasources.chart.xaxisname = this.xAxisName;

      this.dataSource = datasources;
    }

    this.newComplianceInsightScore = this.complianceInsightScore;
  },
  computed: {
    getDataSource() {
      const categories = [];
      const datas = [];

      _get(this.dataSource, ["categories", 0, "category"], []).forEach((val, index) => {
        if (_get(this.dataSource, ["dataset", 0, "data", index, "value"], 0) !== 0) {
          categories.push(val);
          datas.push(this.dataSource.dataset[0].data[index]);
        }
      });

      return {
        ...this.dataSource,
        categories: [
          {
            category: categories
          }
        ],
        dataset: [
          {
            data: datas
          }
        ]
      };
    },
    isShowChart() {
      return this.dataSource.categories && Object.keys(this.dataSource.categories).length > 0 && this.dataSource.dataset && this.dataSource.dataset[0] && this.dataSource.dataset[0].data.filter(row => row.value).length > 0;
    },
    getDiffInsightScore() {
      let diff = "";
      if (this.newComplianceInsightScore && typeof this.newComplianceInsightScore.current !== "undefined" && typeof this.newComplianceInsightScore.last !== "undefined") {
        if (this.newComplianceInsightScore.current.toFixed(1) > this.newComplianceInsightScore.last.toFixed(1)) {
          diff = "+";
        } else if (this.newComplianceInsightScore.current.toFixed(1) < this.newComplianceInsightScore.last.toFixed(1)) {
          diff = "";
        }

        if (this.newComplianceInsightScore.current.toFixed(1) === this.newComplianceInsightScore.last.toFixed(1)) {
          diff += "0.0";
        } else {
          diff += parseFloat(this.newComplianceInsightScore.current - this.newComplianceInsightScore.last).toFixed(1);
        }
      }
      if (!isNaN(diff) && diff != "") {
        return diff;
      }
      return "";
    },
    getComplianceInsightScore() {
      if (this.newComplianceInsightScore && this.newComplianceInsightScore.current && !isNaN(this.newComplianceInsightScore.current)) {
        return parseFloat(this.newComplianceInsightScore.current).toFixed(1);
      } else {
        return "";
      }
    }
  },
  methods: {
    getNumVisPlotByZoom() {
      let numVisPlot = 0;
      switch (this.curZoomLevel) {
        case 0:
          numVisPlot = this.zoomGraphValueChild ? 10 : 5;
          break;
        case 1:
          numVisPlot = this.zoomGraphValueChild ? 8 : 4;
          break;
        case 2:
          numVisPlot = this.zoomGraphValueChild ? 6 : 3;
          break;
        case 3:
          numVisPlot = this.zoomGraphValueChild ? 4 : 2;
          break;
        default:
          break;
      }
      return numVisPlot;
    },
    zoomInChart() {
      if (this.curZoomLevel < this.maxZoomLevel) {
        this.curZoomLevel = this.curZoomLevel + 1;
        const chartRef = this.$refs.overallChart.chartObj;
        const data = chartRef.getJSONData();
        const numVisPlot = this.getNumVisPlotByZoom();
        data.chart.numvisibleplot = numVisPlot;
        chartRef.setJSONData(data);
      }
    },
    zoomOutChart() {
      if (this.curZoomLevel > 0) {
        this.curZoomLevel = this.curZoomLevel - 1;
        const chartRef = this.$refs.overallChart.chartObj;
        const data = chartRef.getJSONData();
        const numVisPlot = this.getNumVisPlotByZoom();
        data.chart.numvisibleplot = numVisPlot;
        chartRef.setJSONData(data);
      }
    },
    getPlotToolText() {
      const defaultToolText = `<div class="overall-collection-metric-tooltip white"'>
                  <span>$label</span><br/>
                  <span class="data-label-text">$dataValue% Non-Compliance</span>
              </div>`;
      return defaultToolText;
    },
    zoomGraph(status) {
      const chartRef = this.$refs.overallChart.chartObj;
      const data = chartRef.getJSONData();
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400";
        this.$emit("zoomEnabled");
        data.chart.numvisibleplot = "10";
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250";
        this.$emit("zoomDisabled");
        data.chart.numvisibleplot = "5";
      }
      chartRef.setJSONData(data);
    },
    downloadCsv(titleChart) {
      this.todayDate = moment()
        .format("DD MMM YYYY hh:mm:ss")
        .toUpperCase();
      this.tDateShow = false;

      setTimeout(() => {
        const header = ["Activities", "% Non-Compliance"];
        const newArr = [];
        header[0] = this.xAxisName;
        this.tDateShow = true;

        this.dataSource.categories[0].category.map(row => {
          newArr.push([row.label]);
        });

        this.dataSource.dataset[0].data.map((row, i) => {
          const value = row.valueCSV ? parseFloat(row.valueCSV).toFixed(2) : row.valueCSV;
          newArr[i].splice(2, 0, value);
        });

        downloadCSV(titleChart, header, newArr, this.specificSiteId);
      }, 1);
    },
    scrollComplianceText(e) {
      if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight - 5) {
        this.isScrolledToBottom = true;
      } else {
        this.isScrolledToBottom = false;
      }
    }
  }
};
</script>

<style lang="scss">
.bg-compliance-insights {
  background-color: #243e64;

  &.no-data-blue {
    background-color: #35537e;

    .bg-dark-blue {
      background-color: #35537e;
    }
  }

  .activity-compliance-score {
    width: 100%;
    max-width: 261px;
    height: 130px;
    background-color: #35537e;
    border-radius: 4px;
    margin-top: 0;
  }

  .btn-round {
    width: 13.3px;
    height: 13.3px;
    opacity: 0.7;
    background-color: #d9d9d9;
  }

  .help-icon {
    color: #d9d9d9;
  }

  .help-icon-hover {
    div {
      font-size: 10px !important;
    }
  }

  .tooltip {
    padding: 8px;
    border-radius: 4px;
    font-family: "Roboto-Medium", sans-serif;
    font-size: 12px;
    color: #ffffff;
    background-color: #c3d5ee;
  }

  .chevron-up {
    width: 0px;
    height: 0px;
    border-left: 19px solid transparent;
    border-right: 19px solid transparent;
    border-bottom: 17px solid #48bf7a;
    margin-left: 5px;
  }

  .chevron-down {
    width: 0;
    height: 0;
    border-left: 19px solid transparent;
    border-right: 19px solid transparent;
    border-top: 17px solid #ff4040;
  }

  .rectangle {
    width: 25px;
    height: 4px;
    margin: 1px 0 0;
    background-color: #959fa4;
  }

  .text-red {
    color: #ff4040;
  }

  .text-green {
    color: #48bf7a;
  }

  .text-grey {
    color: #959fa4;
  }

  .compliance-text {
    font-weight: 300;
    font-family: "Roboto-Light";
    font-size: 16px;
    height: 157px;
    background-color: #10284b;
    padding: 5px;
    cursor: default;
    color: white;
    width: 273px;

    overflow-y: scroll;
    scrollbar-color: #b0bac9 transparent; /* thumb and track color */
    scrollbar-width: 7px;

    &::-webkit-scrollbar {
      width: 7px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #b0bac9;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }

  .align-content-textarea {
    width: 100%;
    height: 157px;
    display: flex;
    background-color: #10284b;
    justify-content: center;
  }

  .activity-compliance-label {
    font-size: 14px;
    color: white;
    font-family: Roboto-Medium;
    font-weight: 500;
  }
  .parent-overlay {
    position: relative;

    .gradient-overlay {
      display: block;
      position: absolute;
      height: calc(156px / 2);
      width: 100%;
      bottom: 0;
      left: 0;
      background: rgb(36, 62, 100);
      background: linear-gradient(180deg, rgba(36, 62, 100, 0) 0%, rgba(36, 62, 100, 1) 100%);
      z-index: 100;
      pointer-events: none;
    }
  }
}

.fusioncharts-container > svg {
  background-color: unset !important;
}

.radius-5 {
  border-radius: 5px;
}

.overall-collection-metric-tooltip {
  padding: 5px !important;
}
</style>
